<template>
  <div>
    <Banner :classType="6" />

    <!-- <div class="bannerW">
      <el-image
        :src="require('@/assets/img/career.jpg')"
        fit="cover"
        class="banner"
      ></el-image>
      <div class="titleBox">
        <h2>融合发展</h2>
        <p>INTEGRATED DEVELOPMENT</p>
      </div>
    </div> -->
    <Menu />

    <div class="pageTitle wow animate__slideInUp">
      <h2>人才理念</h2>
      <p>TALENT CONCEPT</p>
    </div>

    <div class="wrap">
      <el-row class="careerOne">
        <!-- <h3 class="careerOne_tit wow animate__slideInUp" data-wow-delay=".1s">
          {{ talentInfo.TalentConcept.Title }}
        </h3> -->
        <div class="caree_list" style="padding-top:0;">
          <ul>
            <li class="wow animate__slideInUp" data-wow-delay=".2s"  v-for="(item,idx) in TalentConceptList" :key="idx">
              <div class="item flex-ac mgrid">
                <div class="item_pic mx12">
                  <div class="bimg">
                    <img :src="item.PicUrl" alt="" width="100%" />
                  </div>
                </div>
                <div class="item_info mx12">
                  <div class="item_tit fb">{{ item.Title }}</div>
                  <ul>
                    <li v-for="(item2,idx2) in item.Items" :key="idx2">
                        {{ item2 }}
                    </li>
                  </ul>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </el-row>
    </div>

    <div class="careerTwo wow animate__slideInUp" data-wow-delay=".1s">
      <div class="wrap">
        <el-row :gutter="40">
          <el-col :xs="24" :sm="24" :md="12"
            ><h3 class="fb">{{ talentInfo.TalentConceptSubTitle1 }}</h3>
            <el-row :gutter="40">
              <el-col :xs="24" :sm="24" :md="12" class="wow animate__slideInUp">
                <el-image
                  :src="talentInfo.TalentDevelopment.PicUrl"
                  fit="cover"
                  class="imgItem"
                ></el-image>
                <h4 class="fb">{{ talentInfo.TalentDevelopment.Title }}</h4>
                <p
                  v-html="changeValue(talentInfo.TalentDevelopment.Summary)"
                ></p>
              </el-col>
              <el-col
                :xs="24"
                :sm="24"
                :md="12"
                class="wow animate__slideInUp"
                data-wow-delay=".5s"
              >
                <el-image
                  :src="talentInfo.TechnologyRD.PicUrl"
                  fit="cover"
                  class="imgItem"
                ></el-image>
                <h4 class="fb">{{ talentInfo.TechnologyRD.Title }}</h4>
                <p v-html="changeValue(talentInfo.TechnologyRD.Summary)"></p>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12"
            ><h3 class="fb">{{ talentInfo.TalentConceptSubTitle2 }}</h3>
            <el-row :gutter="40">
              <el-col
                :xs="24"
                :sm="24"
                :md="12"
                class="wow animate__slideInUp"
                data-wow-delay="1s"
              >
                <el-image
                  :src="talentInfo.SalarySystem.PicUrl"
                  fit="cover"
                  class="imgItem"
                ></el-image>
                <h4 class="fb">{{ talentInfo.SalarySystem.Title }}</h4>
                <p v-html="changeValue(talentInfo.SalarySystem.Summary)"></p>
              </el-col>
              <el-col
                :xs="24"
                :sm="24"
                :md="12"
                class="wow animate__slideInUp"
                data-wow-delay="1.5s"
              >
                <el-image
                  :src="talentInfo.WelfareTreatment.PicUrl"
                  fit="cover"
                  class="imgItem"
                ></el-image>
                <h4 class="fb">{{ talentInfo.WelfareTreatment.Title }}</h4>
                <p
                  v-html="changeValue(talentInfo.WelfareTreatment.Summary)"
                ></p>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="careerThree">
      <div class="wrap">
        <h2 class="fb">合作高校</h2>
        <el-row :gutter="32" class="wow animate__slideInUp">
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :key="idx"
            v-for="(item, idx) in university"
          >
            <div class="item">
              <div class="item_pic">
                <div class="bimg">
                  <img :src="item.PicUrl" alt="" />
                </div>
              </div>
              <div class="item_tit ep1">{{ item.PicTitle }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="pageBox" v-if="showPage" >
      <Pagination @pageChange="getNewsList" :PagingInfo="PagingInfo" />
    </div>
    <!-- <div class="pageBox">
      <Pagenation />
    </div> -->
  </div>
</template>

<script>
import Menu from "./Menu.vue";
import { WOW } from "wowjs";
import { changeText } from "@/utils/tool";
import Banner from "@/views/components/Banner";
import Pagination from "@/views/components/Pagenation";

export default {
  data() {
    return {
      talentInfo: {
        TalentConcept: {
          Title: "",
          Summary: "",
          PicUrl: "",
        },
        PartnerUniversitiesPicUrls: [],
        TalentDevelopment: {},
        TechnologyRD: {},
        SalarySystem: {},
        WelfareTreatment: {},
      },
      TalentConceptList: {},
      university: [],
      PagingInfo: {},
      showPage:false
    };
  },
  components: {
    Menu,
    Pagination,
    Banner,
  },
  methods: {
    changeValue(value) {
      return changeText(value);
    },
    getNewsList(page, type) {
      this.$api
        .university({
          CurrentPage: page,
          ItemsPerPage: 8,
        })
        .then((res) => {
          // const { NewsItems, PagingInfo } = res.Value;
          const { UniversityList, PagingInfo } = res.Value;
          this.university = UniversityList;
          // this.newsList = NewsItems;
          this.PagingInfo = PagingInfo;
          if (PagingInfo.TotalPages >1) {
            this.showPage = true
          }
          if (type) {
            this.$nextTick(() => {
              new WOW({
                boxClass: "wow",
                animateClass: "animate__animated",
                live: false,
              }).init();
            });
          }
        });
    },
  },
  mounted() {
    this.$api.talent().then((res) => {
      const { Value } = res;
    console.log(res,'+++++2222')
      this.talentInfo = Value;
      this.TalentConceptList = Value.TalentConceptList;
      this.$nextTick(() => {
        new WOW({
          boxClass: "wow",
          animateClass: "animate__animated",
          live: false,
        }).init();
      });
    });
    this.getNewsList(1, "first");
    /* this.$api
      .university({
        ItemsPerPage: 8,
        CurrentPage: 1,
      })
      .then((res) => {
        const { Universities } = res.Value;
        this.university = Universities;
      }); */
  },
};
</script>

<style lang="scss">
/* 人才理念 */
.caree_list {
 
  li {
    margin-bottom: 15px;
    &:nth-child(1){
      margin-top:0
    }
    .item {
      background: #f9f9f9;
    }
    .item_pic,
    .item_info {
      width: 50%;
    }
    .item_info {
      padding-left: 40px;
      .item_tit {
        margin-bottom: 35px;
        font-size: 18px;
        color: #333;
      }
      ul {
        color: #595757;
        line-height:1.6;
        padding-left: 20px;
        li {
          list-style-type: disc;
          margin:5px 0;
          &::marker {
            font-size: 16px;
            color: #c6322d;
          }
        }
      }
    }
  }
}
.careerOne {
  padding: 50px 0;
  overflow: hidden;
  .careerLeft {
    padding-right: 50px;
  }
  .careerOne_tit {
    font-size: 24px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 20px;
  }
  p {
    padding: 40px 0;
    font-size: 18px;
    line-height: 30px;
  }
}
.careerTwo {
  background-color: #f9f9f9;
  padding: 50px 0;
  overflow: hidden;

  .imgItem {
    margin-bottom: 20px;
  }
  h3,
  h4 {
    text-align: center;
    font-size: 24px;
    font-weight: 500;
    padding: 0 0 18px 0;
  }
  h3{
    margin-bottom:20px;
  }
  h4 {
    text-align: left;
    font-size: 24px;
  }
  p {
    line-height: 30px;
  }
}
.careerThree {
  padding: 50px 0 20px;
  overflow: hidden;
  h2 {
    font-size: 24px;
    font-weight: 400;
    padding-bottom: 30px;
  }
  .item {
    height: 202px;
    padding:30px;
    margin-bottom:32px;
    border: 1px solid #BCBCBC;
    text-align: center;
	.bimg{
	text-align:center;
	display:flex;
	justify-content: center;
    align-items: center;
	}
    img{
      height:110px;
	  width:auto;
    }
    .item_tit{
      margin-top:20px;
    }
  }
}
.imgItem {
  transition: all 0.5s;

  &:hover {
    transform: scale(1.05);
  }
}
.jobImgBox {
  background: #f9f9f9;
  display: grid;
  grid-template-columns: repeat(3, 33.33%);
  grid-template-rows: repeat(2, 250px);
}
@media (min-width: 768px) {
  .caree_list {
    li {
      &:nth-child(2n) {
        .item {
          flex-direction: row-reverse;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .el-col-xs-24 {
    padding-top: 20px;
  }
  .careerOne {
    padding: 30px 0;
    p {
      padding-bottom: 15px !important;
    }
  }
  .careerTwo {
    padding: 15px 0;
  }
  .careerOne .careerOne_tit{
    font-size:16px;
  }
  .caree_list li .item_info{
    padding:20px 15px;
  }
  .careerThree .item{
    padding:15px;
    margin:10px -5px;
    height:auto;
  }
  .careerThree .item .item_tit{
    margin-top:5px;
  }
}
</style>
